module.exports = __webpack_public_path__ + "images/emoji/spades.8bfda17df58a25ec5711.png";